import {Component} from '@angular/core';
import {FormBuilder, FormControl, FormGroup} from '@angular/forms';

@Component({
  selector: 'app-form-key-value',
  templateUrl: './form-key-value.component.html'
})

export class FormKeyValueComponent {
  objectKeys = Object.keys;
  grupo: FormGroup;
  config;

// {
//   nome: 'tipo0',
//   editorTipo: 'select',
//   editorOpcoes: {
//     placeholder: 'Tipo 0',
//     opcoes: [
//       {nome: 'texto'},
//       {nome: 'número'},
//       {nome: 'verdadeiro/falso'},
//       ],
//     displayExpr: 'nome',
//     valueExpr: 'nome'
//   },
//   width: 33
// },

  configRows = [{
    config: {
      formNome: 'nested0',
      campos: [
        {
          nome: 'chave0',
          editorTipo: 'input',
          editorOpcoes: {
            placeholder: 'Chave 0',
            tipo: 'text',
            alinhamento: true
          },
          width: 50
        }, {
          nome: 'valor0',
          editorTipo: 'input',
          editorOpcoes: {
            placeholder: 'Valor 0',
            tipo: 'text',
            alinhamento: true
          },
          width: 50
        }
      ]
    }
  }];

  size = 0;

  constructor(private fb: FormBuilder) {
  }

  addKeyValue(i) {
    const size = this.size + 1;

    const chave = {
      nome: 'chave' + size,
      editorTipo: 'input',
      editorOpcoes: {
        placeholder: 'Chave ' + size,
        tipo: 'text',
        alinhamento: true
      },
      width: 50
    };

    const valor = {
      nome: 'valor' + size,
      editorTipo: 'input',
      editorOpcoes: {
        placeholder: 'Valor ' + size,
        tipo: 'text',
        alinhamento: true
      },
      width: 50
    };

    this.configRows[i].config.campos.push(chave);
    this.configRows[i].config.campos.push(valor);

    const arr = Object.assign([], this.configRows);
    this.configRows = [];

    const that = this;
    setTimeout(function () {
      that.configRows = arr;
      that.size += 1;
    }, 200);
  }

  addRow() {
    const config = this.configRows[this.configRows.length - 1];
    config['formNome'] = `nested${this.configRows.length + 1}`;
    this.configRows.push(config);
  }
}
